/** Extracts the filename from a Content-Disposition header (RFC 5987 `filename*` or plain `filename`). */
export const getFilenameFromContentDisposition = (header) => {
    if (!header)
        return null;
    const encoded = header.match(/filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/i);
    if (encoded) {
        try {
            return decodeURIComponent(encoded[1].trim());
        }
        catch {
            // fall through to the plain filename
        }
    }
    const plain = header.match(/filename\s*=\s*(?:"([^"]*)"|([^;]+))/i);
    const value = plain ? (plain[1] ?? plain[2])?.trim() : '';
    return value || null;
};
/** Saves a Blob to disk through a temporary anchor (the browser's download behaviour). */
export const saveBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
};
/** Downloads a successful fetch Response as a file, using the server's filename when it sends one. */
export const downloadResponseAsFile = async (response, fallbackFilename) => {
    const filename = getFilenameFromContentDisposition(response.headers?.get?.('Content-Disposition')) || fallbackFilename;
    saveBlob(await response.blob(), filename);
};
